import React from "react";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  FormCheck,
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import { Formik, ErrorMessage, FieldArray, Field } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import { ButtonDanger } from "../../ui/templates/buttons";
import { ALL_LICENSE_TYPES, EN } from "../../ui/constants";
import ProfileImage from "./profileImage";
import logo from "../../ui/templates/user.png";
import moment from "moment";
import { Box, IconButton } from "@material-ui/core";
import { AddCircleOutline, DeleteOutline } from "@material-ui/icons";
import CancelIcon from "@material-ui/icons/Cancel";
import "../../ui/styles.css";
import { handleLicenseTypeChange } from "../../utils";

class UserPersonalInfoForm extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    this.state = {
      licenses: JSON.parse(user.license || "[]"),
      isLicenseExpiring: false,
      isLicenseExpired: false,
      licenseType: [],
      allLicenseTypes: ["AASA", "RACERS"],
      isMediumScreen: false,
      isLicense: false,
    };
  }

  validateEmail = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  };
  validateEmpty = (value) => {
    let error;

    if (!value) {
      error = "Empty Field";
    }

    return error;
  };
  validatePhoneNumber = (phoneNumber) => {
    let error;
    const digitsOnly = phoneNumber.replace(/\s/g, "");
    if (!/^\d{10}$/.test(digitsOnly) || /\+/.test(phoneNumber)) {
      error = "Invalid phone number";
    }
    return error;
  };
  checkLicenseExpiry(licenses) {
    const currentDate = new Date();
    const sevenDaysFromNow = new Date();
    sevenDaysFromNow.setDate(currentDate.getDate() + 7);
    sevenDaysFromNow.setHours(0, 0, 0, 0);
    const expiryStatusArray = licenses.map((license) => {
      const expiryDate = new Date(license?.date_of_exp);
      expiryDate.setHours(0, 0, 0, 0);
      const differenceInDays = Math.floor(
        (sevenDaysFromNow - expiryDate) / (1000 * 60 * 60 * 24)
      );

      const isLicenseExpiring = differenceInDays > 0 && differenceInDays <= 7;
      const isLicenseExpired = expiryDate < currentDate;

      return {
        licenseType: license?.licenseType,
        expiryDate: license?.date_of_exp,
        isLicenseExpiring: isLicenseExpiring,
        isLicenseExpired: isLicenseExpired,
      };
    });
    const expiringLicenses = expiryStatusArray?.filter(
      (license) => license?.isLicenseExpiring
    );
    const expiredLicenses = expiryStatusArray?.filter(
      (license) => license?.isLicenseExpired
    );

    this.setState({
      isLicenseExpiring: expiringLicenses.length > 0,
      isLicenseExpired: expiredLicenses.length > 0,
      licenseType: [
        ...expiringLicenses?.map((license) => ({
          licenseType: license?.licenseType,
          isLicenseExpiring: license?.isLicenseExpiring,
          isLicenseExpired: license?.isLicenseExpired,
        })),
        ...expiredLicenses?.map((license) => ({
          licenseType: license?.licenseType,
          isLicenseExpiring: license?.isLicenseExpiring,
          isLicenseExpired: license?.isLicenseExpired,
        })),
      ],
    });
  }

  handleCloseModal = () => {
    this.setState({
      isLicenseExpiring: false,
      isLicenseExpired: false,
    });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({
      isMediumScreen: window.innerWidth >= 768 && window.innerWidth <= 1024,
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.checkLicenseExpiry(this.state.licenses);
  }

  render() {
    const { user, handleImageChange, imageSrc, handleUpdateUserProfile } =
      this.props;
    const { isLicenseExpiring, isLicenseExpired, licenseType } = this.state;

    return (
      <>
        <Formik
          initialValues={{
            email: user.email || "",
            nick_name: user.nick_name || "",
            first_name: user.first_name || "",
            last_name: user.last_name || "",
            phone: user.phone || "",
            date_of_birthday:
              moment(user.date_of_birthday).format("YYYY-MM-DD") || "",
            receive_newsletter: user.receive_newsletter || false,
            receive_updates: user.receive_updates || false,
            address: user.address || "",
            post_code: user.post_code || null,
            suburb: user.suburb || "",
            state: user.state || "",
            country: user.country || "",
            image: user.avatar || logo,
            licenses: JSON.parse(user?.license || "[]"),
          }}
          validate={(values) => {
            let errors = {
              email: this.validateEmail(values.email),
              first_name: this.validateEmpty(values.first_name),
              last_name: this.validateEmpty(values.last_name),
              phone: this.validatePhoneNumber(values.phone),
              state: this.validateEmpty(values.state),
            };
            Object.keys(errors).forEach((key) => {
              if (errors[key] === undefined) {
                delete errors[key];
              }
            });

            return errors;
          }}
          onSubmit={(values) => {
            const date = values.date_of_birthday;
            handleUpdateUserProfile(
              values.phone,
              values.country,
              values.address,
              values.nick_name,
              values.first_name,
              values.last_name,
              new Date(date).getTime(),
              imageSrc,
              values.receive_newsletter,
              values.receive_updates,
              values.email,
              values.post_code,
              values.suburb,
              values.state,
              JSON.stringify(values?.licenses || "[]"),
              null
            );
          }}
          enableReinitialize
        >
          {({
            values,
            handleChange,
            handleSubmit,
            handleBlur,
            errors,
            setFieldValue,
          }) => (
            <form
              onSubmit={(...args) => {
                return handleSubmit(...args);
              }}
            >
              <Row>
                <Col xl={3} lg={4} md={10} sm={10} xs={12}>
                  <ProfileImage
                    user={user}
                    image={values.image}
                    imageSrc={imageSrc}
                    handleImageChange={handleImageChange}
                  />
                </Col>
                <Col xl={8} lg={8} md={11} sm={11} xs={12}>
                  <Box className="fontStyle" mb={1} ml={2}>
                    Personal Information
                  </Box>

                  <Row className="justify-content-center">
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Email
                        </Form.Label>
                        <FormControl
                          placeholder="Email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          name="email"
                          type="email"
                          className="form-control"
                          aria-describedby="emailHelp"
                        />
                        <ErrorMessage
                          name="email"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Nickname
                        </Form.Label>
                        <FormControl
                          placeholder="Nickname"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.nick_name}
                          name="nick_name"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          maxLength={20}
                        />
                        <ErrorMessage
                          name="nick_name"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="justify-content-center">
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          First Name
                        </Form.Label>
                        <FormControl
                          placeholder="First Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.first_name}
                          name="first_name"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          maxLength={20}
                        />
                        <ErrorMessage
                          name="first_name"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>

                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Last Name
                        </Form.Label>
                        <FormControl
                          placeholder="Last Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.last_name}
                          name="last_name"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          maxLength={20}
                        />
                        <ErrorMessage
                          name="last_name"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="justify-content-center">
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Phone
                        </Form.Label>

                        <FormControl
                          placeholder="0000 000 000"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                          name="phone"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          maxLength={10}
                        />
                        <ErrorMessage
                          name="phone"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">DOB</Form.Label>

                        <Field
                          type="date"
                          name={`date_of_birthday`}
                          placeholder="yyyy-mm-dd"
                          className="form-control"
                          value={values.date_of_birthday}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Box>
                    <FormGroup as={Col}>
                      <FormCheck
                        checked={values.receive_newsletter}
                        type="checkbox"
                        name="receive_newsletter"
                        value={!!values.receive_newsletter}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="I would like to receive the Motor Events newsletter"
                      />
                    </FormGroup>
                    <FormGroup as={Col}>
                      <FormCheck
                        checked={values.receive_updates}
                        type="checkbox"
                        name="receive_updates"
                        value={!!values.receive_updates}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="I would like to receive updates from Motor Events, including new race info & special offers"
                      />
                    </FormGroup>
                  </Box>

                  <Box width="auto" border="1px solid #dcdcdc" m={2} />
                  <Box className="fontStyle licenseInput" mb={1} ml={2}>
                    License<small style={{ fontWeight: "bold" }}>(s)</small>
                  </Box>
                  <Box ml={2} mr={2} display={["block", "flex"]} mt={1} mb={1}>
                    <Box style={{ margin: "10px 10px 10px 0px" }}>
                      <Button
                        variant="outline-success"
                        as="a"
                        href="https://aasa.com.au/licences/"
                        target="_blank"
                      >
                        AASA Speed licence application
                      </Button>
                    </Box>
                    <Box style={{ margin: "10px 0px" }}>
                      <Button
                        variant="outline-info"
                        as="a"
                        href="https://racers.world/buy-licence/do/new"
                        target="_blank"
                      >
                        RACERS Clubman application
                      </Button>
                    </Box>
                  </Box>

                  <FieldArray name="licenses">
                    {({ remove, push }) => (
                      <div>
                        {values?.licenses?.map((license, index) => {
                          const selectedLicenseTypes = values.licenses
                            .filter((_, i) => i !== index)
                            .map((lic) => lic.licenseType);

                          const availableLicenseTypes =
                            ALL_LICENSE_TYPES.filter(
                              (type) => !selectedLicenseTypes.includes(type)
                            );

                          return (
                            <div key={index}>
                              <Box
                                display="flex"
                                flexDirection={["column", "row"]}
                              >
                                <Box
                                  width={["100%", "30%"]}
                                  padding="0 16px"
                                  order={[2, 1]}
                                >
                                  <FormGroup className="adjustMargin">
                                    <Form.Label className="InputformLabel">
                                      Type
                                    </Form.Label>
                                    <Field
                                      as="select"
                                      name={`licenses[${index}].licenseType`}
                                      className="form-control"
                                      onChange={(event) =>
                                        handleLicenseTypeChange(
                                          event,
                                          index,
                                          values,
                                          setFieldValue
                                        )
                                      }
                                    >
                                      {availableLicenseTypes?.map((item) => (
                                        <option key={item} value={item}>
                                          {item}
                                        </option>
                                      ))}
                                    </Field>
                                  </FormGroup>
                                </Box>
                                <Box
                                  width={["100%", "30%"]}
                                  padding="0 16px"
                                  order={[3, 2]}
                                >
                                  <FormGroup className="adjustMargin">
                                    <Form.Label className="InputformLabel">
                                      Number
                                    </Form.Label>
                                    <Field
                                      type="text"
                                      name={`licenses[${index}].licenseNumber`}
                                      placeholder="License Number"
                                      className="form-control"
                                    />
                                  </FormGroup>
                                </Box>
                                <Box
                                  width={["100%", "30%"]}
                                  padding="0 16px"
                                  order={[4, 3]}
                                >
                                  <FormGroup as={Col} className="adjustMargin">
                                    <Form.Label className="InputformLabel">
                                      Expiry
                                    </Form.Label>
                                    <Field
                                      type="date"
                                      name={`licenses[${index}].date_of_exp`}
                                      placeholder="yyyy-mm-dd"
                                      className="form-control"
                                    />
                                  </FormGroup>
                                </Box>
                                <Box
                                  width={["100%", "10%"]}
                                  display="flex"
                                  justifyContent="end"
                                  order={[1, 4]}
                                  mt={["-45px", "0px"]}
                                  mb={["-55px", "0px"]}
                                >
                                  <FormGroup className="adjustMargin">
                                    <Form.Label className="InputformLabel"></Form.Label>
                                    <Box
                                      mt={2}
                                      className="deleteIconMemberArea"
                                    >
                                      <IconButton
                                        id="deleteHoverNone"
                                        onClick={() => remove(index)}
                                        disabled={
                                          values?.licenses?.length === 1
                                        }
                                      >
                                        <DeleteOutline />
                                      </IconButton>
                                    </Box>
                                  </FormGroup>
                                </Box>
                              </Box>
                            </div>
                          );
                        })}
                        <Box display="flex" alignItems="center">
                          <Box width="100%" border="1px solid #dcdcdc" m={2} />
                          <IconButton
                            id="noHover"
                            style={{ color: "#E00000" }}
                            disabled={values?.licenses?.length === 2}
                            onClick={() => {
                              const usedLicenseTypes = values?.licenses?.map(
                                (license) => license.licenseType
                              );
                              const availableLicenseTypes =
                                ALL_LICENSE_TYPES.filter(
                                  (item) => !usedLicenseTypes.includes(item)
                                );
                              push({
                                licenseType: availableLicenseTypes[0] || "",
                                licenseNumber: "",
                                date_of_exp: "",
                              });
                            }}
                          >
                            <AddCircleOutline fontSize="small" />
                            <span
                              style={{
                                fontSize: "16px",
                                color: "black",
                                marginLeft: "5px",
                                fontWeight: "400",
                                textShadow: "none",
                              }}
                            >
                              Add License
                            </span>
                          </IconButton>
                          <Box width="100%" border="1px solid #dcdcdc" m={2} />
                        </Box>
                      </div>
                    )}
                  </FieldArray>

                  <Box className="fontStyle" ml={2} mb={1}>
                    Address
                  </Box>

                  <Row>
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Address
                        </Form.Label>
                        <FormControl
                          placeholder="Address and street number"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          name="address"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                        />
                        <ErrorMessage
                          name="address"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Post Code
                        </Form.Label>

                        <FormControl
                          placeholder="Post Code"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.post_code}
                          name="post_code"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                        />
                        <ErrorMessage
                          name="post_code"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Suburb
                        </Form.Label>
                        <FormControl
                          placeholder="Suburb"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.suburb}
                          name="suburb"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          maxLength={20}
                        />
                        <ErrorMessage
                          name="suburb"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          State
                        </Form.Label>

                        <select
                          placeholder="State"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.state}
                          name="state"
                          className="form-control"
                          aria-describedby="emailHelp"
                        >
                          <option
                            value=""
                            selected={values.state === ""}
                            disabled
                          >
                            Select State
                          </option>
                          <option
                            value={"NSW"}
                            selected={values.state === "NSW"}
                          >
                            NSW
                          </option>
                          <option
                            value={"QLD"}
                            selected={values.state === "QLD"}
                          >
                            QLD
                          </option>
                          <option
                            value={"VIC"}
                            selected={values.state === "VIC"}
                          >
                            VIC
                          </option>
                          <option value={"SA"} selected={values.state === "SA"}>
                            SA
                          </option>
                          <option value={"WA"} selected={values.state === "WA"}>
                            WA
                          </option>
                          <option value={"NT"} selected={values.state === "NT"}>
                            NT
                          </option>
                          <option
                            value={"TAS"}
                            selected={values.state === "TAS"}
                          >
                            TAS
                          </option>
                        </select>
                        <ErrorMessage
                          name="state"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6} lg={6} xl={6}>
                      <FormGroup as={Col}>
                        <Form.Label className="InputformLabel">
                          Country
                        </Form.Label>
                        <FormControl
                          placeholder="Country"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.country}
                          name="country"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          maxLength={20}
                        />
                        <ErrorMessage
                          name="country"
                          className="submit"
                          component="div"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Col xs={12} md={6} lg={6} xl={6}>
                    <FormGroup>
                      <ButtonDanger type="submit" text={EN.save}></ButtonDanger>
                    </FormGroup>
                  </Col>
                </Col>
              </Row>
            </form>
          )}
        </Formik>
        <Modal
          show={isLicenseExpiring || isLicenseExpired}
          onHide={this.handleCloseModal}
        >
          <Box backgroundColor="#e00000">
            <Modal.Header className="bg-danger text-white">
              <Modal.Title>
                <span
                  className="modal-title"
                  style={{
                    color: "white",
                    height: "30px",
                    fontWeight: "700",
                    fontFamily: "Segoe UI",
                    fontSize: "16px",
                  }}
                >
                  License Expiring Soon!
                </span>
              </Modal.Title>
              <CancelIcon
                onClick={this.handleCloseModal}
                style={{ color: "white", cursor: "pointer", outline: "none" }}
              />
            </Modal.Header>
          </Box>

          <Modal.Body>
            {licenseType?.map((license, index) => (
              <p key={index}>
                Your {license?.licenseType} License{" "}
                {license?.isLicenseExpiring
                  ? "is going to expire!"
                  : "is expired!"}
              </p>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.handleCloseModal}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default UserPersonalInfoForm;
